import { motion } from "motion/react";
import BeyondClassroom from "./BeyondClassroom";
import mobilebg from "../../../assets/mobilebgcampus.png"
import { useEffect } from "react";

export default function NextgenJuniors() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <div className="relative overflow-x-hidden">
     
      
<div
className="w-full h-[60vh] md:min-h-[75vh] bg-cover bg-center bg-no-repeat hidden md:block"
style={{
  backgroundImage: "url('https://dbqa318yoj3nn.cloudfront.net/BG.png')",
}}
>
<div className="flex flex-col md:flex-row items-center justify-between px-6 md:px-20 py-10 h-full">
  {/* Left Image - Empty but kept for structure */}
  <div className="md:w-1/2 w-full flex justify-center mb-6 lg:mb-0"></div>

  {/* Right Content */}
  <div className="md:w-1/2 w-full text-center md:text-left md:mt-[30px] lg:mt-[130px]">
    <div className="flex items-center justify-center lg:justify-center flex-wrap">
      <div
        className="font-bold text-5xl text-black"
        style={{ fontFamily: "Montserrat" }}
      >
        NEXTGEN
      </div>
      <img
        src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        className="w-[30%] max-w-[200px]"
        alt="Juniors"
      />
    </div>

    <div className="flex gap-2 p-4 justify-center md:justify-center mt-5 flex-wrap">
      <div
        className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Think
      </div>
      <div
        className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Imagine
      </div>
      <div
        className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        style={{ fontFamily: "Montserrat" }}
      >
        Achieve
      </div>
    </div>

    <div className="mt-4 px-2">
      <p
        className="text-black tracking-wider font-semibold text-center md:text-[14px] lg:text-[13px] md:text-center"
        style={{ fontFamily: "Poppins" }}
      >
        A program where curiosity meets creativity in an immersive,
        theme-based educational journey for Grades 1–5. Our
        revolutionary approach replaces rote learning with dynamic,
        interdisciplinary exploration, ensuring children grasp concepts
        in a way that is engaging, relevant, and future-ready. With
        hands-on projects, real-world applications, and interactive
        storytelling, we cultivate young minds to think, question, and
        innovate.
      </p>
    </div>
  </div>
</div>
</div>

{/* Mobile Hero Section */}
<div
className="w-full h-auto min-h-[60vh] bg-cover bg-center bg-no-repeat md:hidden"
style={{
  backgroundImage: `url(${mobilebg})`,
}}
>
<div className="flex flex-col items-center justify-between px-6 py-10">
  <div className="w-full text-center">
    <div className="flex items-center justify-center flex-wrap">
      <div
        className="font-bold text-5xl text-black"
        style={{ fontFamily: "Montserrat" }}
      >
        NEXTGEN
      </div>
      <img
        src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        className="w-[30%] max-w-[200px]"
        alt="Juniors"
      />
    </div>

    <div className="flex gap-2 p-4 justify-center mt-5 flex-wrap">
      <div
        className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Think
      </div>
      <div
        className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Imagine
      </div>
      <div
        className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        style={{ fontFamily: "Montserrat" }}
      >
        Achieve
      </div>
    </div>

    <div className="mt-4 px-2">
      <p
        className="text-white text-center text-[14px]"
        style={{ fontFamily: "Poppins" }}
      >
        A program where curiosity meets creativity in an immersive,
        theme-based educational journey for Grades 1–5. Our
        revolutionary approach replaces rote learning with dynamic,
        interdisciplinary exploration, ensuring children grasp concepts
        in a way that is engaging, relevant, and future-ready. With
        hands-on projects, real-world applications, and interactive
        storytelling, we cultivate young minds to think, question, and
        innovate.
      </p>
    </div>
  </div>
</div>
</div>
      <div
        className="w-full bg-cover bg-center bg-no-repeat flex flex-col justify-center overflow-hidden"
        style={{
          backgroundImage: "url('https://dbqa318yoj3nn.cloudfront.net/clouds.png')",
        }}
      >
        <div className="relative flex justify-center items-center pt-[30px] md:pt-[50px]">
          <div
            className="text-4xl md:text-6xl font-bold text-center px-4"
            style={{
              color: "#39B3FF",
              fontFamily: "Luckiest Guy",
              textShadow: "4px 4px 6px rgba(0, 0, 0, 0.2)",
            }}
          >
            THeme-BASeD LeARnInG
          </div>
        </div>

        <motion.div
          whileHover={{ scale: 1.1 }}
          className="flex justify-center mt-4 text-lg md:text-xl text-center px-4 mb-8 md:mb-12 overflow-hidden"
          style={{
            fontFamily: "Montserrat",
            textShadow: "4px 4px 6px rgba(0, 0, 0, 0.4)",
          }}
        >
          Learning beyond books, experiencing beyond limits
        </motion.div>

        <div
          className="relative flex flex-col xl:flex-row items-center justify-center w-full max-w-screen-xl px-4 md:px-8 lg:px-10 py-6 md:py-10 mx-auto gap-8 md:gap-12"
          style={{ fontFamily: "Poppins" }}
        >
          
          <motion.div
            animate={{ y: [0, -15, 0] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="relative w-full xl:w-[55%] max-w-[650px] h-auto flex items-center justify-center order-1 xl:order-none overflow-hidden"
          >
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/yellowstar.png"
              alt="Decorative star background"
              className="absolute w-[70%] md:w-[480px] max-w-full h-auto z-0"
            />
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/staricon.png"
              alt="Fun Learning illustration"
              className="absolute left-0 bottom-4 md:bottom-10 w-[120px] md:w-[250px] lg:w-[300px] max-w-[40%] h-auto z-20"
            />
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/hexagonalimage.png"
              alt="Main educational concept"
              className="relative w-[65%] md:w-[380px] lg:w-[430px] max-w-full h-auto z-10"
            />
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/squareimage.png"
              alt="Supplementary educational image"
              className="absolute right-0 top-0 w-[120px] md:w-[200px] lg:w-[250px] max-w-[30%] h-auto z-10"
            />
          </motion.div>

          
          <div className="w-full xl:w-[45%] max-w-[450px] flex flex-col gap-4 md:gap-6 order-2 xl:order-none">
            {[
              {
                title: "Igniting Young Visionaries",
                text: "Sparks curiosity and sharpens critical thinking beyond traditional methods.",
                bgColor: "bg-purple-200 hover:bg-purple-300",
              },
              {
                title: "Making Learning Fun & Engaging",
                text: "Real-world themes inspire excitement, motivation, and exploration.",
                bgColor: "bg-purple-400 hover:bg-purple-500",
              },
              {
                title: "Fueling Creativity & Innovation",
                text: "Hands-on projects and storytelling kindle imagination and strengthen problem-solving skills.",
                bgColor: "bg-yellow-300 hover:bg-yellow-400",
              },
              {
                title: "Redefining Traditional Education",
                text: "Moving beyond memorization, our approach makes learning immersive and interactive.",
                bgColor: "bg-blue-400 hover:bg-blue-500",
              },
              {
                title: "Preparing Future Leaders",
                text: "Confidence, adaptability, and a passion for discovery equip kids to thrive in a fast-changing world.",
                bgColor: "bg-blue-300 hover:bg-blue-400",
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.02 }}
                className={`flex items-start gap-4 ${item.bgColor} p-4 rounded-xl shadow-md transition-all`}
              >
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full font-bold bg-white text-purple-800 mt-1">
                  {index + 1}.
                </div>
                <div>
                  <h3
                    className="font-bold text-lg md:text-xl"
                    style={{ fontFamily: "Montserrat" }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-sm md:text-base text-gray-700 mt-1"
                    style={{ fontFamily: "Poppins" }}
                  >
                    {item.text}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <BeyondClassroom />
    </div>
  );
}


<div
className="w-screen h-[60vh] md:min-h-[75vh] bg-cover bg-center bg-no-repeat hidden md:block"
style={{
  backgroundImage: "url('https://dbqa318yoj3nn.cloudfront.net/BG.png')",
}}
>
<div className="flex flex-col md:flex-row items-center justify-between px-6 md:px-20 py-10 h-full">
  {/* Left Image - Empty but kept for structure */}
  <div className="md:w-1/2 w-full flex justify-center mb-6 lg:mb-0"></div>

  {/* Right Content */}
  <div className="md:w-1/2 w-full text-center md:text-left md:mt-[30px] lg:mt-[130px]">
    <div className="flex items-center justify-center lg:justify-center flex-wrap">
      <div
        className="font-bold text-5xl text-black"
        style={{ fontFamily: "Montserrat" }}
      >
        NEXTGEN
      </div>
      <img
        src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        className="w-[30%] max-w-[200px]"
        alt="Juniors"
      />
    </div>

    <div className="flex gap-2 p-4 justify-center md:justify-center mt-5 flex-wrap">
      <div
        className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Think
      </div>
      <div
        className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Imagine
      </div>
      <div
        className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        style={{ fontFamily: "Montserrat" }}
      >
        Achieve
      </div>
    </div>

    <div className="mt-4 px-2">
      <p
        className="text-white text-center md:text-[14px] lg:text-[16px] md:text-center"
        style={{ fontFamily: "Poppins" }}
      >
        A program where curiosity meets creativity in an immersive,
        theme-based educational journey for Grades 1–5. Our
        revolutionary approach replaces rote learning with dynamic,
        interdisciplinary exploration, ensuring children grasp concepts
        in a way that is engaging, relevant, and future-ready. With
        hands-on projects, real-world applications, and interactive
        storytelling, we cultivate young minds to think, question, and
        innovate.
      </p>
    </div>
  </div>
</div>
</div>

{/* Mobile Hero Section */}
<div
className="w-screen h-auto min-h-[60vh] bg-cover bg-center bg-no-repeat md:hidden"
style={{
  backgroundImage: `url(${mobilebg})`,
}}
>
<div className="flex flex-col items-center justify-between px-6 py-10">
  <div className="w-full text-center">
    <div className="flex items-center justify-center flex-wrap">
      <div
        className="font-bold text-5xl text-black"
        style={{ fontFamily: "Montserrat" }}
      >
        NEXTGEN
      </div>
      <img
        src="https://dbqa318yoj3nn.cloudfront.net/juniors.png"
        className="w-[30%] max-w-[200px]"
        alt="Juniors"
      />
    </div>

    <div className="flex gap-2 p-4 justify-center mt-5 flex-wrap">
      <div
        className="bg-pink-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-pink-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Think
      </div>
      <div
        className="bg-orange-300 text-black font-bold px-4 py-2 rounded-lg hover:bg-orange-400"
        style={{ fontFamily: "Montserrat" }}
      >
        Imagine
      </div>
      <div
        className="bg-yellow-500 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-600"
        style={{ fontFamily: "Montserrat" }}
      >
        Achieve
      </div>
    </div>

    <div className="mt-4 px-2">
      <p
        className="text-white text-center text-[14px]"
        style={{ fontFamily: "Poppins" }}
      >
        A program where curiosity meets creativity in an immersive,
        theme-based educational journey for Grades 1–5. Our
        revolutionary approach replaces rote learning with dynamic,
        interdisciplinary exploration, ensuring children grasp concepts
        in a way that is engaging, relevant, and future-ready. With
        hands-on projects, real-world applications, and interactive
        storytelling, we cultivate young minds to think, question, and
        innovate.
      </p>
    </div>
  </div>
</div>
</div>